import { GridViewTitleWebComponent } from './component/GridViewTitleWebComponent';
import { WEB_COMPONENT_GRID_VIEW_TITLE } from '../../../webcomponents.constants';

export { GridViewTitleWebComponent };

window.customElements.define(WEB_COMPONENT_GRID_VIEW_TITLE, GridViewTitleWebComponent);
